module.exports = __webpack_public_path__ + "img/vertical_4_7_3.6e9aa62b.png";